<app-dialog-header
    [template]="data && data.template && data.template.header ? data.template.header : headerTemplate"
    (clicked)="onClick($event)"
    *ngIf="!(data && data.exists && data.exists.header == false)"
></app-dialog-header>
<app-dialog-body
    [isLoadingEnable]="isLoadingEnable"
    [template]="data && data.template && data.template.body ? data.template.body : body"
    (clicked)="onClick($event)"
    *ngIf="!(data && data.exists && data.exists.body == false)"
></app-dialog-body>
<app-dialog-footer
    [template]="data && data.template && data.template.footer ? data.template.footer : footerTemplate"
    (clicked)="onClick($event)"
    *ngIf="!(data && data.exists && data.exists.footer == false)"
></app-dialog-footer>

<ng-template #header>
    <div class="modal-header h-56" fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row">
            <mat-icon
                class="font-size-24 mr-12 primary-text-color line-height-28"
                [ngClass]="data?.header?.textColor || ''"
                *ngIf="data && data.header && data.header.icon && data.header.iconMaterialType !== false"
                >{{ data && data.header && data.header.icon ? data.header.icon : "account_box" }}</mat-icon
            >
            <mat-icon
                class="font-size-24 mr-12 primary-text-color line-height-28"
                [ngClass]="data?.header?.icon || ''"
                *ngIf="data && data.header && data.header.icon && data.header.iconMaterialType === false"
            ></mat-icon>
            <p
                class="primary-text-color p-0 m-0 font-size-20 line-height-28"
                [ngClass]="data?.header?.textColor || ''"
            >
                {{ data && data.header && data.header.title ? (data.header.title | translate) : "ADD_INFO" }}
            </p>
        </div>
        <div *ngIf="data && data.header && data.header.closeButton">
            <button mat-icon-button (click)="onCancel()">
                <mat-icon class="font-size-24 line-height-24">close</mat-icon>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #body> </ng-template>

<ng-template #footer>
    <div
        class="modal-footer"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        *ngIf="!(data.footer.cancelButton === false && data.footer.doneButton === false)"
    >
        <div>
            <button
                mat-button
                mat-primary
                [ngClass]="data?.footer?.cancelClass || ''"
                class="font-size-16 cancel-btn secondary-text-color-two legacy-bold"
                (click)="onCancel()"
                *ngIf="!(data && data.footer && data.footer.cancelButton == false)"
            >
                {{
                    data && data.footer && data.footer.cancelButton ? data.footer.cancelButton : ("CANCEL" | translate)
                }}
            </button>
        </div>
        <div>
            <button
                mat-raised-button
                color="primary"
                [ngClass]="data?.footer?.confirmClass || ''"
                class="legacy-bold"
                aria-label="Save"
                *ngIf="!(data && data.footer && data.footer.doneButton == false)"
                (click)="onConfirm()"
                [disabled]="disableConfirm || (data && data.data && data.data.invalid)"
            >
                {{
                    data && data.footer && data.footer.doneButton
                        ? (data.footer.doneButton | translate)
                        : ("SAVE" | translate)
                }}
            </button>
        </div>
    </div>
</ng-template>

<!-- DELETE MODAL PROPERTIES STARTS -->

<!-- DELETE MODAL HEADER -->
<ng-template #deleteHeaderTemplate>
    <!--<div fxLayout="row" fxLayoutAlign="space-between center" class="delete-header pt-20 pb-20 pl-24 pr-24">
    <div fxLayout="row">
      <div class="mr-12">
        <mat-icon class="font-size-24 line-height-36">delete_sweep</mat-icon>
      </div>
      <p class="p-0 m-0 font-size-24">{{(data && data.header && data.header.title)? data.header.title : 'DELETE'}}</p>
    </div> -->
    <!-- <div>
      <button mat-icon-button (click)="onCancel()">
        <mat-icon class="font-size-24 line-height-24">close</mat-icon>
      </button>
    </div>
  </div>-->
</ng-template>

<!-- DELETE MODAL FOOTER -->
<ng-template #deleteFooterTemplate>
    <div fxLayout="row" fxLayoutAlign="space-between center" class="delete-footer pt-16 pb-16 pl-24 pr-24">
        <div>
            <button
                mat-button
                [ngClass]="data?.footer?.cancelClass || ''"
                class="cancel-btn p-0 m-0 font-size-16 secondary-text-color-two legacy-bold"
                aria-label="Cancel"
                (click)="onCancel()"
            >
                {{
                    data && data.footer && data.footer.cancelButton ? data.footer.cancelButton : ("CANCEL" | translate)
                }}
            </button>
        </div>
        <div>
            <button
                mat-raised-button
                color="primary"
                [ngClass]="data?.footer?.confirmClass || ''"
                class="delete-button legacy-bold pl-40 pr-40"
                aria-label="Delete Contact"
                [disabled]="disableConfirm"
                (click)="onConfirm()"
            >
                <mat-icon *ngIf="!(data && data.footer && data.footer.disableIcon)" class="font-size-20 line-height-20"
                    >delete_sweep</mat-icon
                >
                {{
                    data && data.footer && data.footer.doneButton
                        ? (data.footer.doneButton | translate)
                        : ("DELETE" | translate)
                }}
            </button>
        </div>
    </div>
</ng-template>

<!-- confirm MODAL FOOTER -->
<ng-template #confirmationFooterTemplate>
    <div fxLayout="row" fxLayoutAlign="space-between center" class="delete-footer pt-16 pb-16 pl-24 pr-24">
        <div>
            <button
                mat-button
                class="cancel-btn p-0 m-0 font-size-16 secondary-text-color-two legacy-bold"
                aria-label="Cancel"
                (click)="onCancel()"
            >
                {{
                    data && data.footer && data.footer.cancelButton
                        ? (data.footer.cancelButton | translate)
                        : ("CANCEL" | translate)
                }}
            </button>
        </div>
        <div>
            <button
                mat-raised-button
                color="primary"
                class="delete-button legacy-bold pl-40 pr-40"
                aria-label="Delete Contact"
                [disabled]="disableConfirm"
                (click)="onConfirm()"
            >
                {{
                    data && data.footer && data.footer.doneButton
                        ? (data.footer.doneButton | translate)
                        : ("CONFIRM" | translate)
                }}
            </button>
        </div>
    </div>
</ng-template>

<!-- DELETE MODAL PROPERTIES ENDS -->

<!-- Image modal header -->
<ng-template #imageHeaderTemplate>
    <div class="modal-image-container">
        <img src="{{ data && data.header && data.header.imageUrl ? data.header.imageUrl : '' }}" alt="" />
        <div class="modal-title">
            <p class="m-0 p-0 font-size-30 italic line-height-30">
                <span class="colorTitle" *ngIf="data.header.colorTitle">{{
                    data && data.header && data.header.colorTitle | translate
                }}</span>
                {{ data && data.header && data.header.title | translate }}
            </p>
        </div>
    </div>
</ng-template>
